import { useCopyToClipboard } from '@uidotdev/usehooks';
import { Button } from '@/features/button';
import { IconCopy } from '@/features/icons';
import { Modal } from '@/features/modal';
interface Props {
  handleClose: () => void;
}
const ShareModal = ({
  handleClose
}: Props) => {
  const [copiedText, copyToClipboard] = useCopyToClipboard();
  const handleCopyUrl = () => copyToClipboard(window.location.href);
  return <Modal isOpen={true} handleClose={handleClose} title='اشتراک‌گذاری' data-sentry-element="Modal" data-sentry-component="ShareModal" data-sentry-source-file="share-modal.tsx">
            <div className='flex flex-col gap-6'>
                <p className='text-body-16 text-text-black'>برای به اشتراک گذاشتن این محصول، لینک را کپی کنید.</p>

                <Button graphicStyle='outlined' size='large' onClick={handleCopyUrl} className='mx-auto w-fit' icon={{
        element: <IconCopy className='h-6 w-6' />,
        position: 'right'
      }} data-sentry-element="Button" data-sentry-source-file="share-modal.tsx">
                    {copiedText ? 'لینک کپی شد!' : 'کپی کردن لینک'}
                </Button>
            </div>
        </Modal>;
};
export default ShareModal;